import { render } from "./GlobalNavigation.vue?vue&type=template&id=46164ef0&ts=true"
import script from "./GlobalNavigation.vue?vue&type=script&lang=ts"
export * from "./GlobalNavigation.vue?vue&type=script&lang=ts"

import "./GlobalNavigation.vue?vue&type=style&index=0&id=46164ef0&lang=scss"

import exportComponent from "/home/runner/work/billygrossman.com/billygrossman.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__